import { AuthState } from "slices/auth/reducer";

export function hasValidAgency(auth: AuthState): boolean {
    const agencies = auth.user?.agencies;
    return Array.isArray(agencies) && agencies.length > 0 && !!auth.selectedAgencyId;
}
